import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonCheck from './icon-person-check.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonCheck {...validProps} />;
}
SvgComponent.iconName = 'person-check';

/**
 * @deprecated This is a legacy icon
 */
export const PersonCheckIcon = svgIconWrapper(SvgComponent);
